<script>
import {defineComponent} from "vue";
import {useThemesStore} from "@/stores/ThemesStore.js";
import {useOnlineUsersStore} from "@/stores/OnlineUsersStore.js";
import {useAccountStore} from "@/stores/AccountStore.js";
import {useClinicsStore} from "@/stores/ClinicsStore.js";
import {useContractsStore} from "@/stores/ContractsStore.js";
import {useMessagesStore} from "@/stores/MessagesStore.js";
import Theme from "@/models/theme.js";
import GlobalLoadingBar from "@/components/common/GlobalLoadingBar.vue";

export default defineComponent({
    name: "App",
    components: {GlobalLoadingBar},
    async mounted() {
        this.$i18n.locale = useAccountStore().getLocale();
        //document.documentElement.dir = this.textDirection;
    },
    computed: {
        textDirection() {
            return this.$i18n.locale === 'ar' ? 'rtl' : 'ltr';
        }
    },
    watch: {
        '$i18n.locale': async function () {
            await useThemesStore().refreshDefault()
            if (this.selectedContract) {
                if (this.selectedContract?.clinic?.theme) {
                    useThemesStore().setTheme(new Theme(this.selectedContract?.clinic?.theme))
                }
                else {
                    useThemesStore().makeDefault()
                }
            }
            //document.documentElement.dir = this.textDirection;
        }
    }
});
</script>

<template>
    <GlobalLoadingBar />
    <RouterView/>
</template>

<style>

</style>
